var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"eager":"","width":"500"},model:{value:(_vm._open),callback:function ($$v) {_vm._open=$$v},expression:"_open"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }